module.exports = __webpack_public_path__ + "static/media/face-detection- (8).73b33298.jpg";